import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/Header/components/SearchBar/SearchOption/components/SearchOptionTitle/SearchOptionTitle.styles';
import {
  highlightFullMatch,
  highlightPartialMatch,
} from 'components/Header/components/SearchBar/utils/highlightMatch';
import { IFormattedSearch } from 'components/Header/index';

type SearchOptionTitleProps = {
  option: IFormattedSearch;
  inputValue: string;
};
const SearchOptionTitle = ({ option, inputValue }: SearchOptionTitleProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="body2">{highlightFullMatch(option.id, inputValue)}</Typography>
      <Box className={classes.divider} data-testid="divider" />
      <Typography variant="body2">{highlightPartialMatch(option.name, inputValue)}</Typography>
    </Box>
  );
};

export default SearchOptionTitle;
